module.exports = __webpack_public_path__ + "img/decisionModelo.449abd87.svg";